import { render, staticRenderFns } from "./idea.vue?vue&type=template&id=5fd8108e"
import script from "./idea.vue?vue&type=script&lang=js"
export * from "./idea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports